import React from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import Icon from '../icons/Icon'

export default function AccordionComponent({ data, customAccdnClass, accordionInvisible }) {
  return (
    <div className={`accdn ${customAccdnClass} ${accordionInvisible ? 'accdn__invisible' : ''}`}>
      {data &&
        data.length > 0 &&
        data.map((d, index) => (
          <div className={`accdn__item ${data.length - 1 === index && 'accdn__item--last'}`} key={index}>
            <input className='accdn__trigger' id={`accdn-${index}`} type='checkbox' />
            <label className='accdn__title' htmlFor={`accdn-${index}`}>
              <span className='accdn__heading'>{d.title}</span>
              <Icon name='chevron-down' styleModifier='accdn__chevron' size='large' alt='chevron-down' />
            </label>
            <div className='accdn__content-wrapper'>
              <div className='accdn__content'>{d.descriptionHTML ? d.description : <p>{d.description}</p>}</div>
            </div>
          </div>
        ))}
    </div>
  )
}
AccordionComponent.propTypes = {
  data: PropTypes.array,
  customAccdnClass: PropTypes.string,
  accordionInvisible: PropTypes.bool
}

AccordionComponent.defaultProps = {
  data: [],
  customAccdnClass: ''
}
const ExtendedComponent = withTranslation('common')(AccordionComponent)
export { ExtendedComponent as AccordionComponent }
